import _pickBy from 'lodash/pickBy';
import _keys from 'lodash/keys';
import _pick from 'lodash/pick';
import _without from 'lodash/without';
import _mapValues from 'lodash/mapValues';
import _union from 'lodash/union';
import { combineReducers } from 'redux';
import viewAttendeeReducer from '../courses-attendees/viewAttendees/modules/modal/reducer';
import {
  SET_SELECTED_COURSE,
  SET_COURSE_ATTENDEES,
  SET_COURSE_ATTENDEES_ITEMS,
  FILTER_COURSE_ATTENDEE_DATA,
  SELECT_COURSE_ATTENDEE,
  SELECT_ALL_COURSE_ATTENDEES,
  DESELECT_ALL_COURSE_ATTENDEES,
} from './actions';

const INITIAL_STATE = {
  selectedCourse: null,
  courseAttendees: {},
  pending: false,
  chunks: {},
  selected: [],
  items: [],
  filteredChunks: {},
  filter: '',
  error: null,
  filteredChunksAll: {},
};

const filterChunks = (chunks, filterHolder = '') => {
  let filteredChunks = chunks;
  const filter = filterHolder.replace(/[^a-zA-Z0-9 ]/g, '');

  if (filter !== '') {
    filteredChunks = _pickBy(chunks, chunk => {
      const rgx = new RegExp(`(${filter})`, 'gi');
      return (
        rgx.test(chunk.email) ||
        rgx.test(chunk.name) ||
        rgx.test(chunk.userType)
      );
      // return rgx.test(chunk.email);
    });
  }
  const items = Object.keys(filteredChunks);

  return { filteredChunks, items };
};

const coursesAttendees = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SELECT_ALL_COURSE_ATTENDEES: {
      const filteredChunks = _pick(state.filteredChunks, state.items);
      const selectedChunks = _mapValues(filteredChunks, chunk => ({
        ...chunk,
        selected: true,
      }));
      const selected = _union(state.selected, _keys(filteredChunks));

      return {
        ...state,
        filteredChunks: {
          ...state.filteredChunks,
          ...selectedChunks,
        },
        selected,
        selectAll: true,
      };
    }

    case DESELECT_ALL_COURSE_ATTENDEES:
      return {
        ...state,
        filteredChunks: _mapValues(state.filteredChunks, chunk => ({
          ...chunk,
          selected: false,
        })),
        selected: [],
        selectAll: false,
      };

    case SELECT_COURSE_ATTENDEE: {
      const prevState = state.filteredChunks[action.key].selected;

      return {
        ...state,
        filteredChunks: {
          ...state.filteredChunks,
          [action.key]: {
            ...state.filteredChunks[action.key],
            selected: !prevState,
          },
        },
        selected:
          prevState === true
            ? _without(state.selected, action.key)
            : state.selected.concat(action.key),
      };
    }
    case SET_SELECTED_COURSE: {
      return {
        ...state,
        selectedCourse: action.value,
      };
    }
    case SET_COURSE_ATTENDEES: {
      return {
        ...state,
        chunks: action.value,
        selected: [],
        filteredChunks: action.value,
        items: _keys(action.value),
        pending: false,
        error: null,
      };
    }
    case SET_COURSE_ATTENDEES_ITEMS: {
      return { ...state, items: action.value };
    }

    case FILTER_COURSE_ATTENDEE_DATA:
      return {
        ...state,
        ...filterChunks(state.chunks, action.payload),
        filter: action.payload,
      };
    default:
      return state;
  }
};

export default combineReducers({
  listAttendees: coursesAttendees,
  viewAttendee: viewAttendeeReducer,
});
